import { FC, PropsWithChildren } from "react";
import { Controller } from "react-hook-form";
import { ControllerProps } from "react-hook-form";
import { DatePicker, DatePickerProps } from "@mui/x-date-pickers";

interface ReactHookFormDatePickerProps extends DatePickerProps<any> {
  label?: string;
  id?: string;
  controller: Omit<ControllerProps<any>, "render">;
}

const ReactHookFormDatePicker: FC<
  PropsWithChildren<ReactHookFormDatePickerProps>
> = ({ label, controller, children, id, ...props }) => {
  return (
    <Controller
      render={({ field: { onChange, ref, value } }) => (
        <DatePicker
          {...props}
          value={value}
          label={label}
          inputRef={ref}
          slotProps={{
            textField: { size: "small", id, ...props.slotProps?.textField },
          }}
          onChange={onChange}
        />
      )}
      {...controller}
    />
  );
};

export default ReactHookFormDatePicker;
